export default __webpack_public_path__ + "static/slide-07-47fea66823db96a4d85a289ea58099a2.jpg";